<template>
  <div v-if="loading">
    <div class="pt-4 pb-12 flex gap-8 justify-center overflow-hidden">
      <SkeletonLoader class="shrink-0 w-full sm:basis-1/2 xl:basis-1/3 aspect-image" />
      <SkeletonLoader class="hidden sm:block shrink-0 basis-1/2 xl:basis-1/3 aspect-image" />
      <SkeletonLoader class="hidden xl:block shrink-0 basis-1/3 aspect-image" />
    </div>
  </div>
  <EmblaCarousel
    v-else-if="varietyPacks?.length"
    :options="options"
    arrows
    pagination
    aria-label="Product Gallery"
    class="lower-controls pt-4 pb-12"
  >
    <div
      v-for="pack in filteredVarietyPacks"
      :key="pack.title"
      class="embla__slide px-8 flex-center flex-col pb-4"
    >
      <ResponsiveImage
        v-if="pack.featuredImage"
        :image="pack.featuredImage"
        :alt="pack.title"
        :width="480"
        loading="eager"
        class="scale-105 sm:scale-100 aspect-[2/1] object-contain"
      />
      <a
        :aria-label="`Fill box with ${pack.title}`"
        class="button +large +green text-xl min-w-[200px]"
        data-gtm-action="variety pack slider button click"
        :data-gtm-label="pack.title"
        :href="`/products/custom-bundle?curated=${parameterize(pack.title)}&confirmation=modal`"
      >
        <span>Add {{ pack.title }}</span>
      </a>
    </div>
  </EmblaCarousel>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useVarietyPacksStore } from '@/stores'
import { parameterize } from '@/utils'
import ResponsiveImage from '@/components/shared/v2/responsive-image.vue'
import SkeletonLoader from '@/components/shared/v2/skeleton-loader.vue'
import { EmblaCarousel } from '@oatsovernight/storybook'
import type { EmblaOptionsType } from '@oatsovernight/storybook'

const packsStore = useVarietyPacksStore()
const { varietyPacks, loading } = storeToRefs(packsStore)
const filteredVarietyPacks = computed(() => varietyPacks.value?.filter(pack => pack.featuredImage))

const options: EmblaOptionsType = {
  loop: true,
  breakpoints: {
    '(min-width: 640px)': {
      align: (viewSize, snapSize) => (viewSize - snapSize * 2) / 2
    },
    '(min-width: 1280px)': {
      align: 'center'
    }
  }
}

onMounted(packsStore.useVarietyPacks)
</script>

<style scoped>
@reference 'tailwindcss';

.embla__slide {
  @apply basis-full sm:basis-1/2 xl:basis-1/3;
}
</style>